import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { HighOverviewReportTypeRes } from '../../../../api/types/reports/high-overview/high-overview.type';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

interface FilterParams {
  dateRangeStart: Date;
  dateRangeEnd: Date;
}

interface BuildingUtilizationFilterParams {
  dateRangeStart: Date;
  dateRangeEnd: Date;
  timeRangeStart: string;
  timeRangeEnd: string;
}

export const getHighOverviewReport = async (
  setData: (data: HighOverviewReportTypeRes) => any,
  financialMeasuresFilter?: FilterParams,
  examsFilter?: FilterParams,
  buildingUtilizationFilter?: BuildingUtilizationFilterParams,
  academicYear?: number,
) => {
  try {
    const now = new Date();
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const startOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    const currentYear = new Date().getFullYear();

    // Use filter dates for financial measures if provided, otherwise use default
    const financialStartDate =
      financialMeasuresFilter?.dateRangeStart || startOfMonth;
    const financialEndDate =
      financialMeasuresFilter?.dateRangeEnd || startOfNextMonth;

    // Use filter dates for exams if provided, otherwise use default
    const examsStartDate = examsFilter?.dateRangeStart || startOfMonth;
    const examsEndDate = examsFilter?.dateRangeEnd || startOfNextMonth;

    // Use filter dates and times for building utilization if provided, otherwise use default
    const buildingStartDate =
      buildingUtilizationFilter?.dateRangeStart || startOfMonth;
    const buildingEndDate =
      buildingUtilizationFilter?.dateRangeEnd || startOfNextMonth;
    const buildingStartTime =
      buildingUtilizationFilter?.timeRangeStart || '08:00';
    const buildingEndTime = buildingUtilizationFilter?.timeRangeEnd || '20:00';

    const res = await appApi.getHighOverview(
      buildingStartDate, // realEstateUsageDateRangeStart
      buildingEndDate, // realEstateUsageDateRangeEnd
      buildingStartTime, // realEstateUsageTimeInHoursStart
      buildingEndTime, // realEstateUsageTimeInHoursEnd
      academicYear || currentYear, // academicYear
      financialStartDate, // financialMeasureDateRangeStart
      financialEndDate, // financialMeasureDateRangeEnd
      examsStartDate, // examsDateRangeStart
      examsEndDate, // examsDateRangeEnd
    );
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    setData(res.data.body);
  } catch (e) {
    console.error(`getHighOverviewReport is failed with the error: ${e}`);
    toast.error(`משהו קרה, יש לנסות שוב בעוד מספר רגעים...`);
  }
};
